export const quizes3D = [
  "Drag and Drop 3D",
  "Select the Part 3D",
  "Name the Part 3D",
  "Label the Part 3D"
]
export const quizes2D = [
  "Drag and Drop 2D",
  "Select the Element",
  "Connect the Bubbles"
]
